import { render, staticRenderFns } from "./editData.vue?vue&type=template&id=092a17de"
import script from "./editData.vue?vue&type=script&lang=js"
export * from "./editData.vue?vue&type=script&lang=js"
import style0 from "./editData.vue?vue&type=style&index=0&id=092a17de&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports